module.exports = __webpack_public_path__ + "img/banner-mobile.c9c4327d.jpg";